(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["metafield-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boolAttr(el, name) {
      return el.getAttribute(name) === 'true';
    }
    function intAttr(el, name, fallback) {
      var v = parseInt(el.getAttribute(name), 10);
      return isNaN(v) ? fallback : v;
    }

    function initOne(el) {
      var $ = window.jQuery;
      var $el = $(el);
      if ($el.hasClass('slick-initialized')) {
        $el.slick('unslick');
      }
      $el.slick({
        slidesToShow: intAttr(el, 'data-slides-desktop', 3),
        slidesToScroll: 1,
        infinite: boolAttr(el, 'data-infinite'),
        autoplay: boolAttr(el, 'data-autoplay'),
        autoplaySpeed: intAttr(el, 'data-autoplay-speed', 5000),
        arrows: boolAttr(el, 'data-arrows'),
        dots: boolAttr(el, 'data-dots'),
        rtl: boolAttr(el, 'data-rtl'),
        responsive: [
          {
            breakpoint: 990,
            settings: { slidesToShow: intAttr(el, 'data-slides-tablet', 2) }
          },
          {
            breakpoint: 750,
            settings: { slidesToShow: intAttr(el, 'data-slides-mobile', 1) }
          }
        ]
      });
    }

    function initAll(scope) {
      var root = scope || document;
      var sliders = root.querySelectorAll('[data-blog-feed-slider]');
      if (!sliders.length) return;

      // jQuery + Slick are provided by the theme. If Slick isn't ready yet
      // (loaded later in the page), retry briefly rather than erroring out.
      var tries = 0;
      (function ready() {
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
          sliders.forEach(initOne);
        } else if (tries++ < 40) {
          setTimeout(ready, 100);
        } else {
          console.warn('[blog-feed-slider] jQuery/Slick not found on the page.');
        }
      })();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var sliders = e.target.querySelectorAll('[data-blog-feed-slider]');
      sliders.forEach(function (el) {
        if (window.jQuery && window.jQuery(el).hasClass('slick-initialized')) {
          window.jQuery(el).slick('unslick');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
